import Card from 'components/ui/Card';
import { ChoiceType } from 'interfaces/common.interface';
import { EMPTY_STRING, LOG_SUMMARY_OPTION } from 'constants/general';
import HabitDurationCompletion from './HabitDurationCompletion';
import LogData from './LogData';
import YouTubeVideos from './YouTubeVideos';
import FloatingLabelInput from 'components/ui/FloatingLabelInput';
import { LogQuantityQuestion } from 'interfaces';
import { t } from 'services/i18n.service';

interface RandomChoiceFormProps {
  currentChoice: ChoiceType;
  handleChoiceChange: (
    field: keyof ChoiceType,
    value: ChoiceType[keyof ChoiceType]
  ) => void;
  useTimer: boolean;
  setUseTimer: (value: boolean) => void;
}

const RandomChoiceForm = ({
  currentChoice,
  handleChoiceChange,
  useTimer,
  setUseTimer
}: RandomChoiceFormProps) => {
  const logQuestions: LogQuantityQuestion[] =
    currentChoice.log_quantity_questions ?? [];

  const handleLogQuestionsChange = (questions: LogQuantityQuestion[]) => {
    handleChoiceChange('log_quantity_questions', questions);
  };

  return (
    <Card
      variant='ghost'
      className='w-full flex flex-col lg:flex-row ~gap-4/6 ~p-0/1'>
      {/* Left Panel - Form Fields */}
      <div className='w-full lg:w-1/2 flex flex-col ~gap-4/6'>
        <FloatingLabelInput
          type='text'
          placeholder={t('tabs_revamp.random_choice_form.habit')}
          value={currentChoice.name || EMPTY_STRING}
          onChange={(e) => handleChoiceChange('name', e.target.value)}
          size='small'
          variant='default'
          showLabel={true}
          label=''
          error={
            !currentChoice.name?.trim() ? t('validation.empty_content') : ''
          }
        />

        <HabitDurationCompletion
          useTimer={useTimer}
          setUseTimer={setUseTimer}
          durationSeconds={currentChoice.duration_seconds || 0}
          onDurationChange={(seconds) =>
            handleChoiceChange('duration_seconds', seconds)
          }
          completionRequirements={currentChoice.completion_requirements || ''}
          onCompletionRequirementsChange={(value) =>
            handleChoiceChange('completion_requirements', value)
          }
        />

        <LogData
          logQuantity={currentChoice.log_quantity || false}
          onLogQuantityChange={(value) =>
            handleChoiceChange('log_quantity', value)
          }
          logQuestions={logQuestions}
          onLogQuestionsChange={handleLogQuestionsChange}
          logSummaryType={
            currentChoice.log_summary_type || LOG_SUMMARY_OPTION.SUMMATION
          }
          onLogSummaryTypeChange={(value) =>
            handleChoiceChange('log_summary_type', value)
          }
          choiceId={currentChoice.id}
        />
      </div>

      {/* Right Panel */}
      <YouTubeVideos
        videoUrls={currentChoice.video_urls || []}
        onVideoUrlsChange={(urls) => handleChoiceChange('video_urls', urls)}
      />
    </Card>
  );
};

export default RandomChoiceForm;
